<template>
	<el-row :gutter="20">
		<el-col :span="6" v-for="(item, index) in list" :key="index">
			<div class="card course-card" @click="toDetail(item)">
				<div class="course-cover">
					<img class="cover-img" :src="item.image" :alt="item.name +'封面'" />
					<img v-if="item.file_type==1" class="icon-play" src="@/assets/images/icon-play.png" alt="" />
				</div>
				<div class="course-text">
					<div class="course-title line-2">{{ item.name }}</div>
					<div class="course-info">
						<span class="progress">学习进度{{ item.user_progress?.progress_percent||0 }}%</span>
						<el-button type="text" class="free-btn"
							:class="item.type==2?'free-btn-vip':''">{{item.type==2?'vip会员':'免费观看'}}</el-button>
					</div>
				</div>
			</div>
		</el-col>
	</el-row>

</template>

<script>
	export default {
		name: "DynamicCircle",
		props: {
			list: {
				type: Array,
				default () {
					return []
				}
			},
		},
		data() {
			return {

			};
		},

		methods: {
			// 跳转详情
			toDetail(item) {
				const hasLogin = !!localStorage.getItem('token')
				if (!hasLogin) {
					this.$bus.$emit('showLoginModal')
					return
				}
				if (item.type == 2) {
					if (item.is_show == 1) {
						// this.$router.push(`/course/${item.id}`)
						this.$toPage('course/' + item.id)
					} else {
						this.$message.error('vip可看')
					}
				} else {
					// this.$router.push(`/course/${item.id}`);
					this.$toPage('course/' + item.id)
				}
			},

		}
	};
</script>

<style lang="scss" scoped>
	/* 课程卡片样式 */
	.course-card {
		cursor: pointer;
		transition: all 0.3s;
		border-radius: 8px;
		background: #fff;
		padding: 0;
		margin-bottom: 20px;

		&:hover {
			img {
				transform: scale(1.2);
			}
		}

		.course-cover {
			position: relative;
			width: 288px;
			height: 162px;
			overflow: hidden;
			border-radius: 8px 8px 0 0;
			background: #ccc;

			.cover-img {
				width: 288px;
			}

			.icon-play {
				position: absolute;
				left: 14px;
				bottom: 14px;

			}
		}

		.course-text {
			padding: 12px;

			.course-title {
				font-size: 16px;
				font-weight: bold;
			}

			.course-info {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 22px;

				.progress {
					color: #909399;
				}

				.free-btn {
					text-align: center;
					height: 30px;
					padding: 5px 15px;
					color: #28b05e;
					border: 1px solid #28b05e;
					cursor: pointer;
					border-radius: 60px;

					&:hover {
						background-color: #28b05e;
						color: #fff;
					}
				}

				.free-btn-vip {
					color: #FF6910;
					border: 1px solid #FF6910;
					background-color: #FF69101A;

					&:hover {
						background-color: #FF6910;
						color: #fff;
					}
				}
			}
		}
	}
</style>
